import { PaymentAuthSettingsExecutionRule, type PaymentOption } from '@src/domains/payments/types/payment';

export const shouldUseExternalAuthentication = (antifraudErrorCount: number, paymentOption: PaymentOption): boolean => {
  const executionRule = paymentOption.paymentAuthSettings?.executionRule;
  const requiresExternalAuthentication = paymentOption.requiresExternalAuthentication;

  // If executionRule is 'always', execute 3DS before antifraud (always when required)
  if (executionRule === PaymentAuthSettingsExecutionRule.Always) {
    return requiresExternalAuthentication;
  }

  // If executionRule is 'after_antifraud_failure', execute 3DS only after antifraud error
  if (executionRule === PaymentAuthSettingsExecutionRule.AfterAntifraudFailure) {
    const isAntifraudEnabled = paymentOption.antifraudEnabled;

    return (!isAntifraudEnabled || antifraudErrorCount > 0) && requiresExternalAuthentication;
  }

  // Fallback for undefined or unrecognized execution rules
  return false;
};
